import generateUUID from 'uuid/v1'
import { IsRealDevice, isProdEnv } from '..'

const defaults = {
  onSuccess: async (e, log = true) => {
    if (log) console.log('Response', JSON.stringify(e))
    return e
  },
  onError: async (e) => {
    console.error('Error', JSON.stringify(e))
    throw e
  },
}
export const DF2F = {
  UPLOAD_EVENT: 'sendUploadEvent',
  BANK_CLEARING_EVENT: 'sendBankClearingEvent',
  BANK_CLEARING_PREVIEW: 'sendBankPreviewEvent',
  PAYMENT_EVENT: 'sendPaymentEvent',
  SIGNATURE_EVENT: 'sendSignatureEvent',
  REVIEW_DOCUMENT: 'sendReviewDocumentEvent',
  GET_CALL_STATUS: 'getCallStatus',
  GET_MEDIA_STATUS: 'getMediaStatus',
  END_CALL: 'stopVideoCall',
  CONTROL_MEDIA: 'controlMedia',
  OPEN_DF2F_APP: 'openDF2F',
  TOGGLE_SHARE_SCREEN: 'sharingScreen',
  CREATE_NEW_CASE: 'updateAppId',
  CREATE_NEW_POLICY: 'updatePolicyNumber',
  OPEN_ON_BOARDING_STEP: 'openOnBoardingStep',
  ADD_PROPRIETOR_TO_CASE: 'addProprietor',
  UPDATE_PROPRIETOR_IN_CASE: 'updateProprietor',
  RETIREMENT_EVENT: 'sentRetirementEvent',
  RETIREMENT_PREVIEW: 'sentRetirementPreview',
  PAYMENT_RESULT_EVENT: 'sendPaymentResultEvent',
  CANCEL_EVENT: 'sendCancelEvent',
  GET_FRONT_ID_CARD_URL: 'getFrontIdCardUrl',
}

const mockImages = [
  {
    url: 'https://d27zvxcfjgrhx5.cloudfront.net/remote-selling-mock/id_card.jpg',
    fileType: 'image/jpeg',
    name: '1',
    id: generateUUID(),
  },
  {
    url: 'https://d27zvxcfjgrhx5.cloudfront.net/remote-selling-mock/id_card.jpg',
    fileType: 'image/jpeg',
    name: '2',
    id: generateUUID(),
  },
]
const mockRetirement = {
  formData: {
    lastName: 'hh',
    firstName: 'hh',
    bankName: {
      value: '006',
      text: 'ธนาคารกรุงไทย',
      monthlyCollect: 1,
    },
    accountNumber: '111-1-11111-1',
    title: {
      value: 'mr',
      text: 'นาย',
      gender: 'M',
    },
  },
}

const mockPayment = {
  images: [
    {
      url: 'https://d27zvxcfjgrhx5.cloudfront.net/remote-selling-mock/signature.png',
      fileType: 'image/png',
      name: 'eee',
    },
  ],
  success: true,
  selectedBank: {
    bank: {
      text: 'ธนาคารทหารไทยธนชาต',
      value: 'TTB8',
    },
    uploadDate: '2022-12-28T07:48:44.102Z',
  },
}
const mockBankClearing = {
  formData: {
    passportNumber: '',
    lastName: 'hh',
    firstName: 'hh',
    documentType: {
      value: '001',
      text: 'บัตรประจำตัวประชาชน',
    },
    bankName: {
      value: '006',
      text: 'ธนาคารกรุงไทย',
      monthlyCollect: 1,
    },
    accountNumber: '111-1-11111-1',
    title: {
      value: 'mr',
      text: 'นาย',
      gender: 'M',
    },
    accountType: {
      value: 'ออมทรัพย์',
      text: 'ออมทรัพย์',
    },
    relationship: {
      value: 'SELF',
      text: 'ตัวเอง',
    },
    email: '',
    citizenID: '1111111111119',
    phoneNumber: '0948095982',
  },
}

const mockResponse = async (event, payload, onSuccess, onError) => {
  if (isProdEnv) throw new Error('Cannot mock response in production environment')
  switch (event) {
    case DF2F.UPLOAD_EVENT: {
      return onSuccess(mockImages.map((image) => ({ ...image, id: generateUUID() })))
    }
    case DF2F.BANK_CLEARING_EVENT: {
      return onSuccess(mockBankClearing)
    }
    case DF2F.PAYMENT_EVENT: {
      return onSuccess(mockPayment)
    }
    case DF2F.SIGNATURE_EVENT: {
      return onSuccess({ ...mockImages[1], id: generateUUID() })
    }
    case DF2F.REVIEW_DOCUMENT: {
      return onSuccess({ url: 'https://d27zvxcfjgrhx5.cloudfront.net/remote-selling-mock/signature.png' })
    }
    case DF2F.RETIREMENT_PREVIEW: {
      return onSuccess(mockPayment)
    }
    case DF2F.BANK_CLEARING_PREVIEW: {
      return onSuccess(mockPayment)
    }
    case DF2F.RETIREMENT_EVENT: {
      return onSuccess(mockRetirement)
    }
    case DF2F.OPEN_DF2F_APP: {
      return onSuccess({
        name: 'nextStep',
        payload: {
          callStatus: { isAgentStreaming: true, isClientStreaming: true, latency: 4, isInCall: true },
        },
      })
      // -----------------------

      // return onSuccess({
      //   name: 'nextStep',
      //   payload: {
      //     callStatus: { isAgentStreaming: true, isClientStreaming: true, latency: 4 },
      //     mediaStatus: { cameraEnable: false, sharingScreen: false, microphoneEnable: false },
      //   },
      // })
      // ------------------------
      // return onSuccess({
      //   name: 'backToHomePage',
      //   payload: {},
      // })
    }
    case DF2F.GET_FRONT_ID_CARD_URL: {
      return onSuccess({
        insured: {
          idCardImageUrl: 'https://d27zvxcfjgrhx5.cloudfront.net/remote-selling-mock/id_card.jpg',
        },
        payer: {
          idCardImageUrl: 'https://d27zvxcfjgrhx5.cloudfront.net/remote-selling-mock/id_card.jpg',
        },
      })
    }
    case DF2F.GET_MEDIA_STATUS: {
      return onSuccess(
        {
          microphoneEnable: true,
          cameraEnable: true,
        },
        false
      )
    }
    case DF2F.GET_CALL_STATUS: {
      return onSuccess(
        {
          isAgentStreaming: true,
          isClientStreaming: true,
          latency: 1,
          isInCall: true,
        },
        false
      )
    }
    case DF2F.OPEN_ON_BOARDING_STEP: {
      let response = {
        name: 'nextStep',
        payload: { url: 'sd' },
      }
      return onSuccess(response)
    }
    default: {
      return onSuccess(event)
    }
  }
}
export default {
  sendEvent: async (event = '', payload = {}, onSuccess = defaults.onSuccess, onError = defaults.onError) => {
    const ignoreList = [DF2F.GET_MEDIA_STATUS]
    if (!ignoreList.includes(event)) {
      console.log('sendEvent', event, payload)
    }
    return IsRealDevice || isProdEnv
      ? await new Promise((resolve, reject) => {
          window.DF2F.callEvent(
            event,
            payload,
            (e) => resolve(onSuccess(e, !ignoreList.includes(event))),
            (e) => reject(onError(e))
          )
        })
      : await mockResponse(event, payload, onSuccess, onError)
  },
}
